import { mapActions } from 'vuex';

import substrateValidator from '../../_validators/substrateValidator';

export default {
  name: 'SubstrateEditor',
  model: {
    type: 'input',
    prop: 'value',
  },
  props: {
    value: Boolean,
    create: Boolean,
    substrate: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      name: '',
      abbreviation: '',
      color: '#000000',
      paperThickness: 0,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    title() {
      return this.create
        ? 'Create substrate'
        : `Edit substrate: ${this.substrate.name}`;
    },
    nameErrorConfig() {
      return {
        error: !this.name,
        errorMessages: !this.name ? ['Field must be filled!'] : [],
      };
    },
    colorErrorConfig() {
      return substrateValidator.generateColorFieldErrorConfig(this.color);
    },
    paperThicknessErrorConfig() {
      return substrateValidator.generatePaperThicknessFieldErrorConfig(this.paperThickness);
    },
    isInvalidForm() {
      return (this.create ? this.nameErrorConfig.error : false)
        || this.colorErrorConfig.error
        || this.paperThicknessErrorConfig.error;
    },
  },
  watch: {
    value(newValue) {
      if (!newValue || this.create) {
        return;
      }
      this.name = this.substrate.name;
      this.abbreviation = this.substrate.abbreviation;
      this.color = this.substrate.color;
      this.paperThickness = this.substrate.paperThickness;
    },
  },
  methods: {
    ...mapActions('substrates', ['createSubstrate', 'updateSubstrate']),
    submitSubstrateForm() {
      if (this.isInvalidForm) {
        return;
      }

      const action = this.create ? this.createSubstrate : this.updateSubstrate;
      this.$VBlackerTheme.alert.warning({
        text: `${this.create ? 'Create' : 'Update'} substrate?`,
      }, async () => {
        this.$VBlackerTheme.openLoadingSpinner();
        try {
          await action({
            name: this.create ? this.name : this.substrate.name,
            abbreviation: this.abbreviation || null,
            color: this.color,
            paperThickness: this.paperThickness,
          });
          this.$emit('success');
          this.dialog = false;
        } catch (e) {
          this.$VBlackerTheme.notification.error(e);
        } finally {
          this.$VBlackerTheme.closeLoadingSpinner();
        }
      });
    },
    onModalClose() {
      this.name = '';
      this.abbreviation = '';
      this.color = '#000000';
      this.paperThickness = 0;
      this.$emit('update:create', true);
    },
  },
};
